import { useAuth } from "../components/auth/AuthContext";
import Hosailchotels from "./home/hosailchotels.com";
import CityWideHousingSolutions from "./home/citywidehousingsolutions.com";

export default function HomePage() {
  const currentDomain = window.location.hostname;

  // Determine which component to render based on domain
  const renderDomainSpecificContent = () => {
    if (currentDomain.includes('hosailchotels.com')) {
      console.debug("Rendering Hosailchotels for domain:", currentDomain);
      return (
        <Hosailchotels />
      );
    } else {
      // Default to City Wide Housing Solutions for citywidehousingsolutions.com and any other domain
      console.debug("Rendering CityWideHousingSolutions for domain:", currentDomain);
      return (
        <CityWideHousingSolutions />
      );
    }
  };
  
  console.debug("Current domain:", currentDomain);
  return renderDomainSpecificContent();
}